import React from "react";
import "aos/dist/aos.css";

import dataAnalysisImg from "../../assets/dataAn.gif";

const DataAnalysis = () => {
  return (
    <section className="mt-16 w-full py-12 bg-[#F0F8FF]" id="data-analysis">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        {/* Image */}
        <div
          className="w-full md:w-1/2 flex justify-center"
          data-aos="fade-right"
        >
          <img
            src={dataAnalysisImg}
            alt="Illustration Analyse de Données"
            className="w-full max-w-xl md:max-w-2xl rounded-xl shadow-lg"
            loading="lazy"
          />
        </div>
        {/* Texte principal */}
        <div className="mt-12 w-full md:w-1/2" data-aos="fade-left">
          <h2 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
            Analyse et valorisation des données
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Chez <span className="font-semibold text-[#00df9a]">Decintech</span>
            , nous accompagnons nos clients dans la{" "}
            <span className="font-semibold">collecte</span>, l’
            <span className="font-semibold">analyse</span> et la{" "}
            <span className="font-semibold">visualisation</span> de leurs
            données pour transformer l’information brute en leviers de
            croissance.
          </p>
          <ul className="space-y-2 text-base text-gray-800 mb-4">
            <li>
              <span className="font-semibold text-[#00df9a]">Collecte :</span>{" "}
              Mise en place de pipelines automatisés pour recueillir des données
              issues de sources variées (IoT, CRM, web, bases de données...).
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">Nettoyage :</span>{" "}
              Préparation et structuration des données pour garantir leur
              qualité et leur fiabilité.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">Analyse :</span>{" "}
              Application de méthodes statistiques, machine learning et analyses
              exploratoires pour révéler des tendances cachées.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Visualisation :
              </span>{" "}
              Création de tableaux de bord interactifs et de rapports visuels
              dynamiques pour faciliter la prise de décision.
            </li>
            <li>
              <span className="font-semibold text-[#00df9a]">
                Sécurité & Confidentialité :
              </span>{" "}
              Respect strict des normes RGPD et des meilleures pratiques en
              matière de sécurité des données.
            </li>
          </ul>
          <p className="text-gray-600">
            Notre objectif :{" "}
            <span className="font-semibold">valoriser vos données</span> pour
            booster votre performance, anticiper vos besoins futurs et soutenir
            votre transformation digitale.
          </p>
        </div>
      </div>
      {/* Section supplémentaire sous l'image et le texte principal */}
      <div className="max-w-7xl mx-auto mt-2 px-4" data-aos="fade-up">
        <h3 className="text-xl md:text-2xl font-bold text-[#00171f] mb-4">
          Nos technologies et expertises
        </h3>
        <ul className="list-disc pl-6 text-gray-800 space-y-2 mb-6">
          <li>
            <span className="font-semibold text-[#00df9a]">Python & R :</span>{" "}
            Langages puissants pour l’analyse de données, le machine learning et
            l’automatisation des processus analytiques.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Pandas, NumPy :
            </span>{" "}
            Manipulation et traitement efficace de grands volumes de données.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">
              Power BI, Tableau, Plotly :
            </span>{" "}
            Création de visualisations interactives et de tableaux de bord
            dynamiques adaptés à vos besoins métiers.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">SQL :</span>{" "}
            Extraction et gestion de données structurées depuis des bases
            relationnelles.
          </li>
          <li>
            <span className="font-semibold text-[#00df9a]">Sécurité :</span>{" "}
            Mise en place de protocoles de sécurité et de confidentialité pour
            protéger vos données sensibles.
          </li>
        </ul>
        <p className="text-gray-700">
          Notre équipe maîtrise l’ensemble de la chaîne de valeur de la donnée,
          de la collecte à la restitution, en passant par l’analyse avancée et
          la visualisation sur-mesure. Nous sommes à l’écoute de vos enjeux pour
          concevoir des solutions innovantes, performantes et évolutives.
        </p>
      </div>
    </section>
  );
};

export default DataAnalysis;
